import React from 'react';
import { ReflectivePlane } from './reflectivePlane';
import { Background } from "./Background";
import { Lights } from "./Lights";
import { Shadows } from "./Shadows";
import { getPositionV3FromSphericalCoords } from '../utils';
import { genHistFromHdriData, genCdfFromHist } from '../utils/math3d';
import { useThree, useFrame } from '@react-three/fiber';


export const DreiStage = ({
                        intensity = 0,
                        shadows,
                        preset,
                        reflectiveFloor = false,
                        sceneConfig,
                        hdriYRotation,
                        useHdriLightingOnly = false,
                        ...props
                      }) => {
  const [hdriState, setHdriState] = React.useState({hist:null, cdf: null, with:0, height:0});
  const clearHdriState = () => setHdriState({hist:null, cdf: null, with:0, height:0});
  const scene = useThree((state) => state.scene);
  const hdriUuid = scene?.environment?.source?.uuid;
  const shadowDistance = 25;
  const shadowLightPosition = getPositionV3FromSphericalCoords(shadowDistance, shadows.verticalAngle, shadows.horizontalAngle).toArray();

  React.useEffect(() => {
    if (useHdriLightingOnly && scene?.environment?.source?.dataReady) {
      const {width, height, data} = scene.environment.source.data;
      const hist = genHistFromHdriData(data, 100, true);
      const cdf = genCdfFromHist(hist, 5);
      setHdriState({hist, cdf, width, height});
    } else {
      clearHdriState();
    }
    },[scene?.environment?.source?.uuid, scene?.environment?.source?.dataReady, useHdriLightingOnly]
  )

  const hdriData = useHdriLightingOnly ? {hdriYRotation, ...hdriState} : null;

  // Hack: We don't always get the latest scene in useThree.
  // We check every frame that the calculation for the hdri shadow is correct.
  // Otherwise we reset the state to rerender the component and get the correct hdri.
  useFrame((state) => {
    if (useHdriLightingOnly) {
      const sourceUuid = state?.scene?.environment?.source?.uuid;
      if (sourceUuid && (hdriUuid !== sourceUuid)) {
        clearHdriState();
      }
    }
  }, -10);

  return (
    <>
      {!useHdriLightingOnly && <Lights
          castShadow={shadows.enabled}
          intensity={intensity}
          position={shadowLightPosition}
          preset={preset}
      />}
      <Background {...sceneConfig} receiveShadow={false}/>
      {shadows.enabled && <Shadows
        frames={80}
        lightsPosition={shadowLightPosition}
        color={shadows.color}
        opacity={shadows.opacity}
        softness={shadows.softness ?? 0.5}
        hdriData={hdriData}
      />}
      {reflectiveFloor && <ReflectivePlane />}
    </>
  )
};
